module.exports = __webpack_public_path__ + "static/img/anxunu08.13f5d1fa.svg";